export enum EFormType {
  INSTRUCTIONS = 'instructions',
  DATETIME = 'time',
}
